import "../jquery-setup.js";
import Cookies from "js-cookie";
import { debounce } from "./debounce.js";

// Set inside the IIFE below; the router calls it once a new page is in place.
let headerUpdater = () => {};
export const updateHeader = () => headerUpdater(true);

(function ($) {
  "use strict";
  var $window = $(window);
  $window.on("load", function () {
    //---------- Loop through each nav item
    $("nav .nav__menu")
      .children(".nav__dropdown")
      .each(function (indexCount) {
        // loop through each dropdown, count children and apply a animation delay based on their index value
        $(this)
          .children("ul.nav__dropdown-menu")
          .children("li")
          .each(function (index) {
            // Turn the index value into a reasonable animation delay
            var delay = 0.1 + index * 0.03;

            // Apply the animation delay
            $(this).css("animation-delay", delay + "s");
          });
      });
    //----------
  });

  var mainMenu = $("#nav__icon-toggle");
  mainMenu.on('click', function () {
    mainMenu.toggleClass("open");
    $("#navbar-collapse").toggleClass("show");
    $(".main-wrapper").toggleClass("main-wrapper--mobile");
    //console.log("menu clicked");
  });

  /* Detect Browser Size
  -------------------------------------------------------*/
  var minWidth;
  if (Modernizr.mq("(min-width: 0px)")) {
    // Browsers that support media queries
    minWidth = function (width) {
      return Modernizr.mq("(min-width: " + width + "px)");
    };
  } else {
    // Fallback for browsers that does not support media queries
    minWidth = function (width) {
      return $window.width() >= width;
    };
  }

  /* Mobile Detect
  -------------------------------------------------------*/
  if (
    /Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(
      navigator.userAgent || navigator.vendor || window.opera
    )
  ) {
    $("html").addClass("mobile");
  } else {
    $("html").removeClass("mobile");
  }

  /* IE Detect
  -------------------------------------------------------*/
  if (Function("/*@cc_on return document.documentMode===10@*/")()) {
    $("html").addClass("ie");
  }

  /* Sticky Navigation
  -------------------------------------------------------*/
  var c, currentScrollTop = 0;
  // The header's two scroll states: compact once the page has scrolled 40 px,
  // and hidden while scrolling down. Run on scroll, and by the router once a
  // new page is in place (updateHeader below, newPage true), since the scroll
  // position changes then without a scroll event the header should act on. A
  // page just shown has no scroll history: the header is in view, as it is
  // after a full load, whatever the page before it was doing (left scrolled
  // down, it had hidden the header, and the next page arrived without one).
  function updateHeader(newPage) {
    $.fn.scrollToTop();
    var $navHolder = $(".nav__holder");
    if (newPage === true) {
      c = undefined;
      $navHolder.removeClass("scrollUp");
    }

    if ($window.scrollTop() > 40) {
      $navHolder.addClass("nav__holder--sticky");
    } else {
      $navHolder.removeClass("nav__holder--sticky");
    }

    //only hide nav on scroll up if mobile nav not expanded
    if (!$(".nav__wrap.show").length) {
      var a = $window.scrollTop();
      var b = $navHolder.height();
      currentScrollTop = a;
      if (c < currentScrollTop && a > b + b) {
        $navHolder.addClass("scrollUp");
      } else if (c > currentScrollTop && !(a <= b)) {
        $navHolder.removeClass("scrollUp");
      }
      c = currentScrollTop;
    }
  }
  $window.on('scroll', debounce(updateHeader, 5)); // ~60fps instead of every scroll event
  headerUpdater = updateHeader;

  /* Mobile Navigation
  -------------------------------------------------------*/
  $(".nav__dropdown-trigger").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).parent().removeClass("expanded");
    } else {
      $(this).addClass("active");
      $(this).parent().addClass("expanded");
    }
  });

  // On a phone a tap outside the menu hides any open dropdown panel and a tap
  // inside shows them again. One handler on the body reads where the tap landed;
  // until 31 October 2026 the inside case stopped the click's propagation, which
  // also kept every tap on a menu link from reaching the router, so the menu
  // navigated with full page loads and no fade (docs/prd/2026-10-31-router-page-changes.md).
  if ($("html").hasClass("mobile")) {
    $("body").on("click", function (event) {
      $(".nav__dropdown-menu").toggleClass("hide-dropdown", !event.target.closest(".nav__dropdown"));
    });
  }

  /* Accordion
  -------------------------------------------------------*/
  var $accordion = $(".accordion");

  function toggleChevron(e) {
    $(e.target)
      .prev(".accordion__heading")
      .find("a")
      .toggleClass("accordion--is-open accordion--is-closed");
  }
  $accordion.on("hide.bs.collapse", toggleChevron);
  $accordion.on("show.bs.collapse", toggleChevron);

  /* Tabs
  -------------------------------------------------------*/
  // $(".tabs__trigger").on("click", function (e) {
  //   var currentAttrValue = $(this).attr("href");
  //   $(".tabs__content-trigger " + currentAttrValue)
  //     .stop()
  //     .fadeIn(1000)
  //     .siblings()
  //     .hide();
  //   $(this)
  //     .parent("li")
  //     .addClass("tabs__item--active")
  //     .siblings()
  //     .removeClass("tabs__item--active");
  //   e.preventDefault();
  // });


  /*-------------------------------------------------------
  CUSTOM JQUERY PROTOTYPE FUNCTIONS
  -------------------------------------------------------*/

/* Business email validator
-------------------------------------------------------*/
//fn is an alias for jQuery. prototype which allows jQuery to be extended with custom functions.
$.fn.isPersonalEmail = function (email) {
  // Add safety check for undefined or null email
  if (!email || typeof email !== 'string') {
    return false; // Treat invalid emails as personal (will be rejected)
  }
  
  var personalDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "aol.com",
    "msn.com",
    "comcast.net",
    "live.com",
    "outlook.com",
    "ymail.com",
    "icloud.com",
    "gmail.co.uk",
    "yahoo.co.uk",
    "hotmail.co.uk",
    "aol.co.uk",
    "msn.co.uk",
    "comcast.net",
    "live.co.uk",
    "outlook.co.uk",
    "ymail.co.uk",
    "icloud.co.uk",
    "proton.me",
    "protonmail.com",
    "comcast.com",
    "comcast.net",
    "freenet.de",
    "zohomail.eu",
    "me.com",
  ];
  
  // Check if email contains @ symbol
  if (email.indexOf('@') === -1) {
    return false; // Treat emails without @ as personal (will be rejected)
  }
  
  var emailDomain = email.split("@")[1];
  emailDomain = emailDomain.toLowerCase();
  return personalDomains.includes(emailDomain);
};

  $.fn.submitRecord = function (formObject) {
    //apply utm tags to a cookie and hidden fields before submitting
    $.fn.setUtm();

    $.ajax({
      url: "/api/create.php",
      type: "POST",
      data: formObject.serialize(),
      dataType: "json",
      success: function (data) {
        //console.log(data);
        //console.log("gotcha");
      },
      error: function (data) {
        //console.log(data);
        //console.log("ajax error");
      },
    });
  };

  $.fn.getReferrer = function (formObject) {
    $.fn.setUtm();

    formObject = $(formObject);

    $.ajax({
      url: "/api/refcheck.php",
      type: "POST",
      data: formObject.serialize(),
      dataType: "json",
      success: function (data) {
        //formObject.find();

        formObject
          .find(".client-contact__referral-banner-text")
          .text(data.name);
        formObject
          .find(".client-contact__referral-banner-icon")
          .attr("style", "background-image:url(" + data.image + ")");
        if (data.status == "found") {
          formObject
            .find(".client-contact__referral-banner")
            .addClass("client-contact__referral-banner--active");
        }
        
        //console.log(data);
        //return json_decode(data);
      },
      error: function (data) {
        //console.log(data.responseText);
      },
    });
  };

  $.fn.getReferralCode = function (formObject) {
    $.ajax({
      url: "/api/referral.php",
      type: "GET",
      dataType: "json",
      success: function (data) {
        //console.log(data);
        //return json_decode(data);
        formObject
          .find(".success-panel__referral-code")
          .text("https://growthcurve.co/start-growing?referrer=" + data);
        formObject.find(".referral_code").val(data);
      },
      error: function (data) {
        //console.log("ajax error");
      },
    });
  };

  $.fn.updateRecord = function (formObject) {
    //apply utm tags to a cookie and hidden fields before submitting
    $.fn.setUtm();

    $.ajax({
      url: "/api/update.php" + "?rand=hashdshd",
      type: "POST",
      data: formObject.serialize(),
      dataType: "json",
      success: function (data) {},
      error: function (data) {},
    });
  };

  $.fn.sendSms = function (phoneNumber) {
    /* start ajax submission process */
    $.ajax({
      url: "/api/sms.php",
      type: "POST",
      data: phoneNumber,
      dataType: "json",
      success: function (data, textStatus, jqXHR) {
        //alert('Success!');
        // $('.modale').addClass('opened');
        //console.log(data);

        window.dataLayer.push({
          event: "smsSendSuccess",
          //'eventCallback' : redirectCallback
          //'registrationCountry': 'Great Britain',
          //'plan': 'Premium'
        });
      },
      error: function (jqXHR, textStatus, errorThrown) {
        //alert(errorThrown);
        window.dataLayer.push({
          event: "smsSendFail",
          //'eventCallback' : redirectCallback
          //'registrationCountry': 'Great Britain',
          //'plan': 'Premium'
        });
      },
    });
  };

  $.fn.queryCalendly = function (eventId, inviteeId, callback) {
    /* start ajax submission process */
    $.ajax({
      url: "/api/calendly.php",
      type: "POST",
      data: {
        event_id: eventId,
        invitee_id: inviteeId
      },
      dataType: "json",
      success: function (data, textStatus, jqXHR) {
        //('Calendly query success:', data);

        window.dataLayer.push({
          event: "calendlyQuerySuccess",
        });
        
        // Call the callback function with the data
        if (callback && typeof callback === 'function') {
          callback(data);
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        //console.log('Calendly query error:', errorThrown);
        
        window.dataLayer.push({
          event: "calendlyQueryFail",
        });
      },
    });
  };

  $.fn.utmQuery = decodeURIComponent(window.location.search.substring(1));

  $.fn.injectJs = function (scriptUri, location = "head") {
    var script = document.createElement("script");
    script.setAttribute("src", scriptUri);
    script.setAttribute("type", "text/javascript");
    if(location == "footer"){
    document.getElementsByTagName("body")[0].appendChild(script);
    }else{
      document.getElementsByTagName("head")[0].appendChild(script);
    }
  };

  $.fn.getUTMValue = (inputParameter) => {
    var ParameterName = [];
    let utmVariables = $.fn.utmQuery.split("&");
    var i;

    for (i = 0; i < utmVariables.length; i++) {
      ParameterName = utmVariables[i].split("=");
      if (ParameterName[0] === inputParameter) {
        return ParameterName[1] === null ? null : ParameterName[1];
      }
    }
  };

  $.fn.valueExists = (value) => {
    return value != null && value != "" && value != undefined;
  };

  $.fn.setUtm = function () {

    const utmParams = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
      "referrer",
    ];

    utmParams.forEach((param) => {
      var pValue = $.fn.getUTMValue(param);

      if ($.fn.valueExists(pValue)) {
        // Try to set cookie, but don't let failure prevent hidden field setting
        try {
          Cookies.set(param, pValue, {
            //domain: 'localhost',
            expires: 90,
          });
        } catch (error) {
          // Cookies are disabled or failed - this is expected in private browsing
         // console.warn(`Cookie setting failed for ${param}:`, error.message);
         console.log(error);
        }

        // Always set the hidden field with the URL parameter value
        // This ensures tracking works even when cookies are disabled
        let input = document.getElementById(param);
        if (input) {
          input.value = pValue;
        }
      } else {
        // If no URL parameter, try to get from cookie as fallback
        try {
          let cValue = Cookies.get(param);
          let input = document.getElementById(param);
          if (input && $.fn.valueExists(cValue)) {
            input.value = cValue;
          }
        } catch (error) {
          console.log(error);
          // Cookies are disabled - this is expected in private browsing
          //console.warn(`Cookie reading failed for ${param}:`, error.message);
        }
      }
    });
  };


  // $.fn.setUtm = function () {
  //   const Cookies = require("js-cookie");

  //   const utmParams = [
  //     "utm_source",
  //     "utm_medium",
  //     "utm_campaign",
  //     "utm_content",
  //     "utm_term",
  //     "referrer",
  //   ];

  //   utmParams.forEach((param) => {
  //     var pValue = $.fn.getUTMValue(param);

  //     if ($.fn.valueExists(pValue)) {
  //       Cookies.set(param, pValue, {
  //         //domain: 'localhost',
  //         expires: 90,
  //       });
  //     }
  //     let cValue = Cookies.get(param);
  //     let input = document.getElementById(param);
  //     if (input && $.fn.valueExists(cValue)) {
  //       input.value = cValue;
  //     }
  //   });
  // };

  /* Scroll to Top
  -------------------------------------------------------*/
  $.fn.scrollToTop = function () {
    var scroll = $window.scrollTop();
    var $backToTop = $("#back-to-top");
    if (scroll >= 50) {
      $backToTop.addClass("show");
    } else {
      $backToTop.removeClass("show");
    }
  };

  $('a[href="#top"]').on("click", function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      0,
      "easeInQuint"
    );
    return false;
  });

  /* Owl Carousel
  -------------------------------------------------------*/

})(jQuery);
